import isEmail from 'validator/es/lib/isEmail';
import type { GeneralSettings } from '../../../../../../shared/settings/general';
import useOrganizationSettings from '../../../shared/useOrganizationSettings';
import { useAddToast } from '../../../../../contexts/ToastContext';

/**
 * A hook for fetching and updating general settings.
 */
const useGeneralSettings = (organizationId: number) => {
  const onAddToast = useAddToast();
  const {
    settings,
    initialSettings,
    onSaveSettingsWithOverride,
    errors,
    isLoading,
    onUpdateSettings,
    isSaveButtonDisabled,
  } = useOrganizationSettings<GeneralSettings>({
    endpoint: `/api/organizations/${organizationId}/settings/general`,
    settingsSection: 'general',
  });

  const onSave = (): void => {
    if (!settings?.title) {
      onAddToast({ type: 'error', content: `Organization title is required.` });
      return;
    }
    if (settings?.email && !isEmail(settings?.email)) {
      onAddToast({ type: 'error', content: `Billing email is invalid.` });
      return;
    }

    onSaveSettingsWithOverride({
      ...settings,
      //  The BE expects that we will send the labels as an array of strings.
      labels: settings?.labels?.map(({ label }) => label) ?? [],
      packageLabels: settings?.packageLabels?.map(({ name }) => name) ?? [],
    } as unknown as GeneralSettings);
  };

  return {
    settings,
    initialSettings,
    isSaveButtonDisabled,
    onUpdateSettings,
    isSaving: isLoading.save,
    isLoading: isLoading.fetch,
    errors,
    onSave,
  };
};

export default useGeneralSettings;
